export const MERCHANT_ID_REGEXP = /\/merchants\/(\d*)/;

export const INTERNAL_EMAIL_DOMAINS = ["flipp.com", "wishabi.com"];



// WEBPACK FOOTER //
// ./client/modules/common/constants.ts